import script from "./NoBsPromotionClassic.vue?vue&type=script&setup=true&lang=js"
export * from "./NoBsPromotionClassic.vue?vue&type=script&setup=true&lang=js"

import "./NoBsPromotionClassic.vue?vue&type=style&index=0&id=2c207b3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c207b3d"]])

export default __exports__